import { render, staticRenderFns } from "./AssistanceButton.vue?vue&type=template&id=549ca4f6&scoped=true&"
import script from "./AssistanceButton.vue?vue&type=script&lang=js&"
export * from "./AssistanceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549ca4f6",
  null
  
)

export default component.exports